import { privacyPolicy } from '@/content/policies';

export function usePrivacyText() {
  return {
    privacyText: privacyPolicy,
  };
}
